import * as React from "react"
import styled from "styled-components"
import { Spacer } from "../spacers"
import H3 from "../typography/H3"

interface Props {
  onChange: (value: string) => void
  defaultValue?: string
  title: string
}

const RoleSelect = styled.select`
  outline: none;
  border: none;
  font-size: 16px;
  color: ${(props) => props.theme.colors.greyDark};
  font: inherit;
  background-color: transparent;
`

const SelectRoleContainer = styled.div`
  display: flex;
  align-items: center;
`

const SelectRoleDropdown: React.FunctionComponent<Props> = ({ onChange, defaultValue, title }) => {
  return (
    <SelectRoleContainer>
      <H3>{title}</H3>
      <Spacer spacing={0.5} />
      <RoleSelect name="roleType" onChange={(e) => onChange(e.target.value)} defaultValue={defaultValue}>
        <option value="Viewer">Viewer</option>
        <option value="Admin">Admin</option>
      </RoleSelect>
    </SelectRoleContainer>
  )
}

export default SelectRoleDropdown
